import type { Translate } from '@/plugins/i18n/types';
import { inject } from 'vue';
import { useToast } from 'vue-toastification';

export function useCopyToClipboard() {
  const t = inject('t') as Translate;
  const toast = useToast();

  function copy(text: string) {
    // Copy the text inside the text field
    navigator.clipboard.writeText(text);

    toast.success(t('general.link_copied'));
  }

  return { copy };
}
